<template lang="pug" src="./v-navigation.pug"></template>
<style lang="scss">
.hiddenClickable {
  cursor: default !important;

  &:focus:after {
    opacity: 0 !important;
  }
}
</style>

<script>
import {mapGetters} from 'vuex';
import {prepareDeliveryItems} from '@/services/navigation.service';

export default {
  props: {
    right: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    requestProcessing: false,
    counter: 0
  }),
  computed: {
    ...mapGetters(['loggedIn', 'roleName', 'user', 'currentBranch', 'operator', 'roleName']),
    navDrawer: {
      get() {
        return this.$store.state.data.drawer;
      },
      set(drawer) {
        this.$store.commit('data/SET_DRAWER', drawer);
      }
    },
    menu() {
      return [{
        name: 'receiveOrders',
        to: {path: '/receive-orders'},
        icon: 'phone',
        roles: ['intern', 'corporate-user', 'admin-delivery', 'admin-establishment', 'manager-establishment', 'manager-establishment-ext'],
        loggedIn: true
      }, {
        name: 'formAnswers',
        to: {path: '/form-answers'},
        icon: 'mdi-format-list-checks',
        roles: ['manager'],
        loggedIn: true
      }, {
        name: 'dispatcher',
        roles: ['operator', 'admin'],
        icon: 'mdi-account-box',
        loggedIn: true,
        children: [{
          name: 'receiveOrders',
          to: {path: '/receive-orders'},
          roles: ['operator', 'admin'],
          icon: 'phone',
          loggedIn: true
        }, {
          name: 'formAnswers',
          to: {path: '/form-answers'},
          icon: 'mdi-format-list-checks',
          roles: ['operator', 'admin'],
          loggedIn: true
        }, {
          name: 'technicalSupport',
          to: {path: '/technical-support'},
          icon: 'mdi-face-agent',
          roles: ['operator', 'admin'],
          loggedIn: true
        }]
      },
        ...prepareDeliveryItems(this.roleName),
        {
          name: 'deliveryReports',
          to: {path: '/delivery-reports'},
          icon: 'move_to_inbox',
          roles: ['admin-establishment'],
          loggedIn: true
        },
        {
          name: 'driverNews',
          to: { path: '/*' },
          icon: 'feed',
          roles: ['admin'],
          loggedIn: true,
          children: [
            {
              name: 'addDriverArticle',
              to: { path: '/add-driver-article' },
              icon: 'send',
              roles: ['admin'],
              loggedIn: true
            },
            {
              name: 'articleList',
              to: { path: '/driver-news' },
              icon: 'newspaper',
              roles: ['admin'],
              loggedIn: true
            }
          ]
        },
        {
          name: 'history',
          to: {path: '/history'},
          icon: 'history',
          roles: ['intern', 'operator', 'manager', 'boss', 'admin', 'corporate-admin', 'corporate-user', 'admin-delivery', 'manager-establishment', 'admin-establishment', 'manager-establishment-ext'],
          loggedIn: true
        },
        {
          name: 'map',
          to: {path: '/dashboard-map'},
          icon: 'map',
          roles: ['boss', 'admin', 'manager', 'accountant'],
          loggedIn: true
        }, {
          name: 'finances',
          icon: 'receipt',
          roles: this.getAvailableRoles('finances'),
          loggedIn: true,
          children: [{
            name: 'tariffs',
            icon: 'mdi-align-vertical-bottom',
            roles: this.getAvailableRoles('tariffs'),
            loggedIn: true,
            to: {path: '/finances/tariffs'}
          }, {
            name: 'commissions',
            icon: 'mdi-align-horizontal-right',
            roles: this.getAvailableRoles('commissions'),
            loggedIn: true,
            to: {path: '/finances/commissions'}
          }, {
            name: 'commission-systems',
            icon: 'mdi-finance',
            roles: ['admin'],
            loggedIn: true,
            to: {path: '/finances/commission-systems'}
          }, {
            name: 'penalties',
            icon: 'mdi-alert-octagon',
            roles: this.getAvailableRoles('penalties'),
            loggedIn: true,
            to: {path: '/finances/penalties'}
          }, {
                    name: 'optionClasses',
                    icon: 'mdi-format-EstablishmentsList-bulleted-type',
                    roles: ['admin', 'boss', 'manager'],
                    loggedIn: true,
                    to: { path: '/finances/option-classes' }
                }, /*{
                    name: 'paymentTypes',
                    icon: 'mdi-credit-card-settings-outline',
                    roles: ['admin', 'boss', 'manager'],
                    loggedIn: true,
                    to: { path: '/finances/payment-types' }
                }*/]
        }, {
          name: 'users.drivers',
          icon: 'mdi-account-card-details',
          roles: ['boss'],
          loggedIn: true,
          to: {path: '/users/drivers'}
        }, {
          name: 'users',
          icon: 'people',
          roles: ['admin', 'manager', 'corporate-admin', 'operator', 'accountant', 'admin-delivery', 'admin-establishment'],
          loggedIn: true,
          children: [{
            name: 'operators',
            icon: 'mdi-account-key',
            roles: ['admin', 'corporate-admin', 'admin-delivery', 'admin-establishment'],
            loggedIn: true,
            to: {path: '/users/operators'}
          }, {
            name: 'drivers',
            icon: 'mdi-account-card-details',
            roles: ['operator', 'accountant', 'manager', 'admin'],
            loggedIn: true,
            to: {path: '/users/drivers'}
          }, {
            name: 'clients',
            icon: 'mdi-nature-people',
            roles: ['operator', 'admin'],
            loggedIn: true,
            to: {path: '/users/clients'}
          }]
        }, {
          name: 'reports',
          to: {path: '/reports'},
          icon: 'move_to_inbox',
          roles: ['accountant', 'manager', 'boss', 'admin', 'corporate-admin', 'leader'],
          loggedIn: true
        }, {
          name: 'forms',
          to: {path: '/forms'},
          icon: 'list_alt',
          roles: ['admin'],
          loggedIn: true
        }, {
          name: 'bonuses',
          icon: 'loupe',
          roles: ['admin'],
          loggedIn: true,
          children: [{
            name: 'driver',
            icon: 'mdi-account-group-outline',
            loggedIn: true,
            to: {path: '/bonuses/driver'}
          }, {
            name: 'client',
            icon: 'mdi-account-group',
            loggedIn: true,
            to: {path: '/bonuses/client'}
          }]
        }, /*{
          name: 'addresses',
          to: {path: '/addresses'},
          icon: 'mdi-city',
          roles: ['operator', 'admin', 'intern', 'corporate-user'],
          loggedIn: true
        }, */{
          name: 'notifications',
          to: {path: '/notifications'},
          icon: 'notifications',
          roles: ['admin', 'boss', 'manager'],
          loggedIn: true
        }, {
          name: 'logging',
          to: {path: '/logging'},
          icon: 'access_time',
          roles: ['admin'],
          loggedIn: true
        }, {
          name: 'login',
          to: {path: '/login'},
          icon: 'account_circle',
          loggedIn: false
        }, {
          name: 'resales',
          icon: 'import_export',
          roles: ['admin'],
          loggedIn: true,
          to: {path: '/resales'}
        }, {
          name: 'brands',
          icon: 'work',
          roles: ['admin', 'admin-delivery'],
          loggedIn: true,
          to: {path: '/brands'}
        }, {
          name: 'photoReport',
          icon: 'mdi-image-outline',
          roles: ['admin', 'manager'],
          loggedIn: true,
          children: [{
            name: 'reasons',
            icon: 'mdi-file-question-outline',
            roles: ['admin', 'manager'],
            loggedIn: true,
            to: {path: '/photo-report/reasons'}
          }, {
            name: 'reports',
            icon: 'mdi-image-edit',
            roles: ['admin', 'manager'],
            loggedIn: true,
            to: {path: '/photo-report/reports'}
          }]
        }, {
          name: 'settings',
          icon: 'settings',
          roles: this.getAvailableRoles('settings'),
          loggedIn: true,
          children: [{
            name: 'admin',
            icon: 'settings_system_daydream',
            loggedIn: true,
            to: {path: '/settings/admin'}
          }, {
            name: 'boss',
            icon: 'settings_overscan',
            loggedIn: true,
            to: {path: '/settings/boss'}
          }]
        }];
    },
    routeName() {
      const {meta} = this.$route;
      if (!meta) {
        return;
      }

      return meta.useTitle ? `${meta.name}.title` : `${meta.name}`;
    }
  },
  created: function () {
    this.$store.commit('data/SET_DRAWER', false);
  },
  methods: {
    getAvailableRoles(path) {
      const roles = ['admin'];
      const {extendedCapabilities} = this.operator || {};
      const managerPaths = ['finances', 'tariffs', 'commissions', 'penalties'];

      if (managerPaths.includes(path)) {
        roles.push('manager');
      }

      if (['boss'].includes(this.roleName) && extendedCapabilities) {
        roles.push('boss');
      }

      return roles;
    },
    incrementCounter() {
      // this.counter++;
      //
      // if (this.counter === 13) {
      //   window.open('https://www.youtube.com/watch?v=dQw4w9WgXcQ');
      // }
    },
    showRoute(route) {
      const isShow = route.loggedIn ? this.loggedIn : !this.loggedIn;

      if (this.roleName) {
        return (!route.roles || route.roles.includes(this.roleName)) && isShow;
      }

      return isShow;
    },
    logout() {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      this.$store.dispatch('auth/logout').then(() => {
        this.$nextTick(() => this.requestProcessing = false);
      });
    }
  }
};
</script>
